var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showing)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleVis}},[_vm._v(" Hide ")]):_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleVis}},[_vm._v(" Show ")]),(_vm.showing)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }